import { toast } from "react-toastify";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { api, apiInsurance } from "../helpers/api";

export const initApp = () => {
  const token = localStorage.getItem("worldPayToken");
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
};
export const initInsuranceApp = () => {
  const token = localStorage.getItem("worldPayToken");
  apiInsurance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const useAuth = create(
  devtools((set) => ({
    user: {
      structure_card_id: null,
    },
    loading: false,
    confirmCodeLoading: false,
    message: null,
    success: false,
    isGuest: false,
    step: 1,
    login: async (params) => {
      set({ loading: true, message: null });
      try {
        const response = await api.post("/login", params);
        const token = await response?.data?.data?.user?.auth_key;
        const success = await response?.data?.success;
        set({
          user: await response?.data?.data?.user,
          loading: false,
          success: success,
          message: null,
        });
        if (success === false) {
          toast.error(useAuth.getState().message);
        }
        return response;
      } catch (err) {
        toast.error(err?.response?.data?.error?.message);
        console.log(err, "err");
        return err;
      } finally {
        set({ loading: false });
      }
    },
    confirmCode: async (params) => {
      set({ confirmCodeLoading: true });
      try {
        const response = await api.post("/confirm-code", params);
        return response?.data;
      } catch ({ response }) {
        return response;
      } finally {
        set({ confirmCodeLoading: false });
      }
    },
    resendSms: async (params) => {
      set({ resendSmsLoading: true });
      try {
        const response = await api.post("/resend-sms", params);
        return response.data
      } catch (err) {
        return err;
      } finally {
        set({ resendSmsLoading: false });
      }
    },
    fetchMe: async () => {
      set({ loading: true, message: null });
      try {
        const response = await api.get("/me");
        const me = await response?.data?.data;
        const isGuest = await response?.data?.success;
        set({
          user: me,
          isGuest: isGuest,
          loading: false,
        });
        if (response?.data?.success === false) {
          localStorage.removeItem("worldPayToken");
          // window.history.pushState("", "", "/login");
        } else {
        }
        return response.data;
      } catch (err) {
        return err;
      } finally {
        set({ loading: false });
      }
    },
    // Set success
    setSuccess: (params) => {
      set((state) => ({ success: params }));
    },
    // Set step
    setStep: (params) => {
      set((state) => ({ step: params }));
    },
    // Logout
    logout: () => {
      set({ user: {} });
      localStorage.removeItem("worldPayToken");
    },
  }))
);

export default useAuth;
